<template>
    <div >
        <Tabs value="name1"  @on-click="slitTag" style="min-height:400px">
            <div slot="extra" style="width:500px">
                <Row>
                    <Col span="6" style="position: relative;top: 10px;">
                         总订单数 {{headerdata.numbers}}
                    </Col>
                    <Col span="6" style="position: relative;top: 10px;">
                        订单金额 {{headerdata.allmoney}}
                    </Col>
                    <Col span="12" align="right">
                        <DatePicker
                                split-panels
                                type="daterange"
                                :options="options"
                                placeholder="选择日期"
                                @on-change="handleOk"
                                :value="valuedate"
                                style="width: 80%;">
                        </DatePicker>
                    </Col>
                </Row>
            </div>
            <TabPane label="待付款" name="name1">
                <Card class="historyItem" :dis-hover="false" v-for="(item, index) in goodsListL" :key="index"  @click.native="opencommodityModal(item)">
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==3">自提</p>
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==1">快递</p>
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==2">物流</p>
                    <ul class="type-content">
                        <li>  实收金额：￥{{item.totalMoney}} </li>
                        <li>  买家：{{item.username}} </li>
                        <li>  小计：{{item.qery}}  款 {{item.nums}} 件</li>
                        <li>  时间：{{item.createtime}} </li>
                        <li>  单号：{{item.ordercode}} </li>
                    </ul>
                </Card>
            </TabPane>
            <TabPane label="已付款" name="name2">
                <Card class="historyItem" :dis-hover="false" v-for="(item, index) in goodsListL" :key="index" @click.native="openonlinePayModal(item)">
                <!-- <Card class="historyItem" :dis-hover="false" v-for="(item, index) in goodsListL" :key="index" @click.native="$router.push({path:'/openorder',query:{id:item.id}})"> -->
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==3">自提</p>
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==1">快递</p>
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==2">物流</p>
                    <ul class="type-content">
                        <li>  实收金额：￥{{item.totalMoney}} </li>
                        <li>  买家：{{item.username}} </li>
                        <li>  小计：{{item.qery}} 款 {{item.nums}} 件</li>
                        <li>  时间：{{item.createtime}} </li>
                        <li>  单号：{{item.ordercode}} </li>
                    </ul>
                </Card>
            </TabPane>
            <TabPane label="已确认" name="name3">
                <!-- <Form  inline  :label-width="80" >
                    <FormItem label="店铺" v-if="isCustomerSharing==1">
                        <Select v-model="searchshopName" filterable style="width: 200px">
                            <Option
                                    v-if="k.isCustomerSharing==1 || k.isgeneralwarehouse=='Y'"
                                    :value="k.id"
                                    v-for="(k,v) in shopList"
                                    :key="v">{{k.name}}</Option>
                        </Select>
                    </FormItem>
                </Form> -->
                <Card class="historyItem" :dis-hover="false" v-for="(item, index) in goodsListL" :key="index" @click.native="$router.push({path:'/openorderDertail',query:{appletCode:item.ordercode}})">
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==3">自提</p>
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==1">快递</p>
                    <p slot="title" style="color: #46bab2;" v-if="item.deliverymethod==2">物流</p>
                    <ul class="type-content">
                        <li>  实收金额：￥{{item.totalMoney}} </li>
                        <li>  买家：{{item.username}} </li>
                        <li>  小计：{{item.qery}} 款 {{item.nums}} 件</li>
                        <li>  时间：{{item.createtime}} </li>
                        <li>  单号：{{item.ordercode}} </li>
                    </ul>
                </Card>
            </TabPane>
        </Tabs>
        <div class="pageTotal">
            <Page  :total="page.total"
                   show-total
                   :page-size="page.rows"
                   @on-change="onChange" />
        </div>
        <!--未支付订单弹框-->
        <Modal
                width="90%"
                v-model="commodityModal"
                title="新增销售单">
            <Form>
                <FormItem>
                    <strong>{{formdata.shoptype}}</strong><br>
                    <strong>{{formdata.shopname}}</strong>
                </FormItem>
                <FormItem>
                    <div class="boximg">
                        <Fy-Img
                                class="img"
                                :ImgSrc="formdata.Img | filtImg(formdata.Img)"
                                :Width="100"
                                :Height="100"
                        ></Fy-Img>
                        <Row>
                            <Col span="5">
                                <h3>{{formdata.shopnames}}({{formdata.goodscode}})</h3>
                                <p>{{formdata.ordernumber}}</p>
                                <p>{{formdata.shopcolor}}   </p>
                            </Col>
                            <Col span="3">
                                <p>规格</p>
                                <p v-for="(item,index) in colorarray"> {{item.size}}</p>
                            </Col>
                            <Col span="3">
                                <strong>颜色</strong>
                                <p v-for="(item,index) in colorarray"> {{item.color}}</p>
                            </Col>

                              <Col span="3">
                                   <p>数量</p>
                                   <p v-for="(item,index) in colorarray"> {{item.num}}</p>
                               </Col>
                        </Row>
                    </div>
                    <Divider />
                </FormItem>
              <FormItem>
                  <Row>
                      <Col span="3">
                          商品金额 ：￥{{formdata.shopmoneys}}
                      </Col>
                      <Col span="3">
                          客户欠款 ：{{formdata.shopkehu}}
                      </Col>

                      <Col span="3">
                          本单欠款 ：{{formdata.shopqiankuan.toFixed(2)}}
                      </Col>

                      <Col span="3" v-if="isShowflagadmin">
                          客户积分 ：{{formdata.integral}}
                      </Col>
                      <Col span="3" v-if="isShowflagadmin">
                          本单积分 ：{{bendanIntegral}}
                      </Col>

                      <Col span="5">
                          商品抹零 ： <InputNumber :max="99999999" :min="0" v-model.trim="formdata.moling" style="width: 100px" ></InputNumber>
                          <Button  @click="moling" style="margin-left: 5px">抹零</Button>
                      </Col>
                      <Col span="4">  业务员：
                          <Select
                                  :disabled="ruleflag"
                                  v-model="formdata.salesperson"
                                  filterable
                                  style="width: 120px">
                              <Option :value="formdata.currentAdminid"> {{formdata.currentAdmin}}</Option>
                              <Option :value="k.id" v-for="(k,v) in formdata.salesman" :key="v"  >{{k.name}}</Option>
                          </Select>
                      </Col>
                  </Row>
              </FormItem>
                <FormItem>
                    <Row v-if="isShowflagadmin">
                        <Col span="4">选择优惠 ：
                            <Select v-model="choose.res "  style="width: 150px" >
                                <Option :value="k.id"
                                        v-for="(k,v) in choose.discountList"
                                        :key="v"
                                        :disabled="discountListStatus==k.state|| (discountListStatus==3&&k.state==1) ||(discountListStatus==3&&k.state==2)">{{k.label}}
                                </Option>
                            </Select>
                        </Col>
                        <Col span="4"  v-if="choose.res==4">
                            <strong>结算账户:</strong> <span style="color: #ff5e5e"> 会员卡</span>
                        </Col>

                        <Col span="4"  v-if="choose.res==4">
                            会员卡余额 ： <span style="color: #ff5e5e"> ￥{{kehudata.balance}}</span>
                        </Col>
                        <Col span="8" v-if="choose.res==2">
                            优惠规则 ：每消费 {{jfData.consume}}元 获得 {{jfData.integral}} 积分，每使用 {{jfData.employ}} 积分可抵扣 ￥{{jfData.deposit}}  共可抵扣 ￥{{jfdkmoney.toFixed(2)}}
                        </Col>
                        <Col span="4"  v-if="choose.res==4">
                            <strong>会员卡扣除:</strong> <span style="color: #ff5e5e"> ￥{{formdata.allmoney}}</span>
                        </Col>
                        <Col span="4"  v-if="choose.res==3">
                            优惠规则 ： 积分折扣 {{zhekoulv}}%
                        </Col>

                    </Row>
                    <Divider />
                    <Row>
                        <Col span="6"  v-if="choose.res!=4">结算账户:
                            <Select v-model="formdata.bank" style="width: 150px">
                                <Option :value="k.type" v-if="k.type!=6" v-for="(k,v) in formdata.bankList" :key="v"  >{{k.bankname}}</Option>
                            </Select>
                        </Col>
                        <Col span="6" v-if="choose.res!=4">
                            实付金额 ： <InputNumber  v-model.trim="formdata.money" :max="99999999" :min="0" :precision="2"  style="width: 100px"></InputNumber>
                        </Col>
                        <Col span="4">
                            发货方式 ：
                            <span v-if="formdata.type==3">自提</span>
                            <span v-if="formdata.type==1">快递</span>
                            <span v-if="formdata.type==2">物流</span>
                        </Col>
                    </Row>
                    <Divider />
                </FormItem>
                <FormItem>
                    <Row>
                        <Col span="4">
                            客户姓名 ： <Input type="text" v-model.trim="formdata.name"  style="width: 100px"></Input>
                        </Col>
                        <Col span="4">
                            联系方式 ： <Input type="text" v-model.trim="formdata.phone"  style="width: 100px"></Input>
                        </Col>
                        <Col span="4">
                            收货地址 ： <Input type="text" v-model.trim="formdata.address"  style="width: 100px"></Input>
                        </Col>
                        <Col span="4">
                            客户留言 ：{{formdata.remark}}
                        </Col>
                    </Row>
                </FormItem>
                <FormItem>
                    <Row>
                        <Col span="4">
                            商品件数 ：{{formdata.count}}
                        </Col>
                        <Col span="4">
                            合计 ： ￥{{formdata.allmoney.toFixed(2)}}
                        </Col>
                    </Row>
                </FormItem>
            </Form>

            <div slot="footer">
                <Button type="text" @click="commodityModal=false">取消</Button>

                <Button type="primary" @click="addsSelectItem()" :loading="addsSelectItemloading">
                    <span v-if="!addsSelectItemloading">出售 </span>
                    <span v-else>出售中 </span>
                </Button>
            </div>
        </Modal>
        <!--已支付订单弹框-->
        <Modal
                width="90%"
                v-model="onlinePayModal"
                title="新增销售单">
            <Form>
                <FormItem>
                    <strong>{{formdata.shoptype}}</strong><br>
                    <strong>{{formdata.shopname}}</strong>
                </FormItem>
                <FormItem>
                    <div class="boximg">
                        <Fy-Img
                                class="img"
                                :ImgSrc="formdata.Img | filtImg(formdata.Img)"
                                :Width="100"
                                :Height="100"
                        ></Fy-Img>
                        <Row>
                            <Col span="5">
                                <h3>{{formdata.shopnames}}({{formdata.goodscode}})</h3>
                                <p>{{formdata.ordernumber}}</p>
                                <p>{{formdata.shopcolor}}   </p>
                            </Col>
                            <Col span="3">
                                <p>规格</p>
                                <p v-for="(item,index) in colorarray"> {{item.size}}</p>
                            </Col>
                            <Col span="3">
                                <strong>颜色</strong>
                                <p v-for="(item,index) in colorarray"> {{item.color}}</p>
                            </Col>

                              <Col span="3">
                                   <p>数量</p>
                                   <p v-for="(item,index) in colorarray"> {{item.num}}</p>
                               </Col>
                        </Row>
                    </div>
                    <Divider />
                </FormItem>
              <FormItem>
                  <Row>
                      <Col span="3">
                          商品金额 ：￥{{formdata.shopmoneys}}
                      </Col>
                      <Col span="3">
                          客户欠款 ：{{formdata.shopkehu}}
                      </Col>

                      <Col span="3">
                          本单欠款 ：{{formdata.shopqiankuan.toFixed(2)}}
                      </Col>

                      <Col span="3" v-if="isShowflagadmin">
                          客户积分 ：{{formdata.integral}}
                      </Col>
                      <Col span="3" v-if="isShowflagadmin">
                          本单积分 ：{{bendanIntegral}}
                      </Col>

                      <!-- <Col span="5">
                          商品抹零 ： <InputNumber :max="99999999" :min="0" v-model.trim="formdata.moling" style="width: 100px" ></InputNumber>
                          <Button  @click="moling" style="margin-left: 5px">抹零</Button>
                      </Col> -->
                      <Col span="4">  业务员：
                          <Select
                                  :disabled="ruleflag"
                                  v-model="formdata.salesperson"
                                  filterable
                                  style="width: 120px">
                              <Option :value="formdata.currentAdminid"> {{formdata.currentAdmin}}</Option>
                              <Option :value="k.id" v-for="(k,v) in formdata.salesman" :key="v"  >{{k.name}}</Option>
                          </Select>
                      </Col>
                  </Row>
              </FormItem>
                <FormItem>
                    <Row v-if="isShowflagadmin">
                        <Col span="4">选择优惠 ：
                            <Select v-model="choose.res "  style="width: 150px" >
                                <Option :value="k.id"
                                        v-for="(k,v) in choose.discountList"
                                        :key="v"
                                        :disabled="discountListStatus==k.state|| (discountListStatus==3&&k.state==1) ||(discountListStatus==3&&k.state==2)">{{k.label}}
                                </Option>
                            </Select>
                        </Col>
                        <Col span="4"  v-if="choose.res==4">
                            <strong>结算账户:</strong> <span style="color: #ff5e5e"> 会员卡</span>
                        </Col>

                        <Col span="4"  v-if="choose.res==4">
                            会员卡余额 ： <span style="color: #ff5e5e"> ￥{{kehudata.balance}}</span>
                        </Col>
                        <Col span="8" v-if="choose.res==2">
                            优惠规则 ：每消费 {{jfData.consume}}元 获得 {{jfData.integral}} 积分，每使用 {{jfData.employ}} 积分可抵扣 ￥{{jfData.deposit}}  共可抵扣 ￥{{jfdkmoney.toFixed(2)}}
                        </Col>
                        <Col span="4"  v-if="choose.res==4">
                            <strong>会员卡扣除:</strong> <span style="color: #ff5e5e"> ￥{{formdata.allmoney}}</span>
                        </Col>
                        <Col span="4"  v-if="choose.res==3">
                            优惠规则 ： 积分折扣 {{zhekoulv}}%
                        </Col>

                    </Row>
                    <Divider />
                    <Row>
                        <Col span="6"  v-if="choose.res!=4">结算账户:
                            <Select v-model="formdata.bank" style="width: 150px" :selected="selected">
                                <Option :value="k.type" :v-if="k.type!=6" v-for="(k,v) in formdata.bankList" :key="v"  >{{k.bankname}}</Option>
                            </Select>
                        </Col>
                        <Col span="6" v-if="choose.res!=4">
                            实付金额 ： <InputNumber  v-model.trim="formdata.money" :max="99999999" :min="0" :precision="2"  style="width: 100px"></InputNumber>
                        </Col>
                        <Col span="4">
                            发货方式 ：
                            <span v-if="formdata.type==3">自提</span>
                            <span v-if="formdata.type==1">快递</span>
                            <span v-if="formdata.type==2">物流</span>
                        </Col>
                    </Row>
                    <Divider />
                </FormItem>
                <FormItem>
                    <Row>
                        <Col span="4">
                            客户姓名 ： <Input type="text" v-model.trim="formdata.name"  style="width: 100px"></Input>
                        </Col>
                        <Col span="4">
                            联系方式 ： <Input type="text" v-model.trim="formdata.phone"  style="width: 100px"></Input>
                        </Col>
                        <Col span="4">
                            收货地址 ： <Input type="text" v-model.trim="formdata.address"  style="width: 100px"></Input>
                        </Col>
                        <Col span="4">
                            客户留言 ：{{formdata.remark}}
                        </Col>
                    </Row>
                </FormItem>
                <FormItem>
                    <Row>
                        <Col span="4">
                            商品件数 ：{{formdata.count}}
                        </Col>
                        <Col span="4">
                            合计 ： ￥{{formdata.allmoney.toFixed(2)}}
                        </Col>
                    </Row>
                </FormItem>
            </Form>

            <div slot="footer">
                <Button type="text" @click="onlinePayModal=false">取消</Button>

                <Button type="primary" @click="addsSelectItem()" :loading="addsSelectItemloading">
                    <span v-if="!addsSelectItemloading">出售 </span>
                    <span v-else>出售中 </span>
                </Button>
            </div>
        </Modal>
        <Modal v-model="opengreatHy" width="360">
            <p slot="header" style="text-align:center">
                <span>提示</span>
            </p>
            <div style="text-align:center">
                <p>当前没有会员卡收据账户，是否创建？</p>
            </div>
            <div slot="footer">
                <Button type="primary" size="large" long @click="$router.push('/accountGl')">创建</Button>
            </div>
        </Modal>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                select:null,
                addsSelectItemloading:false,
                userid:'',
                orderId:'',
                searchNeirong:'',
                goodsListL:[],
                yujingListL:[],
                headerdata:{
                    numbers:0,
                    allmoney:0,

                },
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },

                /*弹框*/
                commodityModal:false,//未已支付订单
                onlinePayModal:false,//已支付订单
                /*弹框数据*/
                resData:{},
                kehudata:{},//客户返回值
                jfData:{},//积分规则
                jfdkmoney:0,//积分共抵扣多少钱
                bendanIntegral:0,//本单积分
                discountListStatus:0,
                choose:{
                    res:1,
                    discountList:[{ //选择优惠
                        id: 1,
                        label: '无优惠',
                        state: 0
                    },{
                        id: 2,
                        label: '积分抵现',
                        state: 2
                    },{
                        id: 3,
                        label: '积分打折',
                        state: 1

                    },{
                        id: 4,
                        label: '会员卡',
                        state: 4
                    }]
                },
                colorarray:[],
                formdata:{
                    shoptype:"",
                    customerid:'',//客户id
                    goodscode:'',//货号
                    shopname:'',
                    money:0,
                    salesman:[],
                    bank:'3',
                    bankList:[],
                    currentAdminid:JSON.parse(localStorage.getItem('adminUser')).id,
                    currentAdmin:JSON.parse(localStorage.getItem('adminUser')).name,
                    salesperson:'',
                    address:'',
                    phone:'',
                    name:'',
                    Img:'',
                    sizes:'',//规格
                    num:0,//数量
                    shopnames:'', //商品名
                    ordernumber:'',//商品编号
                    shopcolor:"",
                    shopmoney:'',
                    allmoney:0,//共计金额
                    count:0,//共计件数
                    shopmoneys:0,//商品今额
                    shopqiankuan:0,//本单欠款
                    shopkehu:0,//客户欠款
                    moling:0,//商品抹零
                    allmoneymolis:0,//抹零相加
                    type:'',//发货方式
                    remark:'',//客户留言
                },
                opengreatHy:false, //创建会员卡提示弹框
                isShowflagadmin:false, //客户类型 false 默认客户
                monlingjieyu:0,
                constmerArr:[],//积分设置初始化
                zhekoulv:100,//积分折扣率
                chooseType:1, //选择的优惠方式类型
                Usejf:0,
                ruleflag:false,
                isCustomerSharing:0, //客户共享是否开启 0关 1开
                shopList:[],
                searchshopName:'',
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
            this.valuedate[0] = this.fun_date(-30)
            this.valuedate[1] = this.nowTime
            this.getAdminList()
            this.getBankList()
            this.getShopList()
            this.getOrderList(this.page.page,this.page.rows,0,this.valuedate[0],this.valuedate[1])
            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('84')){
                this.ruleflag=true
            }
        },
        watch: {
            //修改优惠方式
            'choose.res': {
                deep: true,
                handler: function (newVal, oldVal) {
                   this.chooseType=newVal
                   //判断优惠方式是否可选择
                    var istype = 0
                    this.formdata.bankList.forEach((item) => {
                        if (item.type == 6) {
                            istype = item.type
                        }
                    })
                    if (istype == 0) {
                        this.opengreatHy = true
                        this.formSelect.discount = 1
                    }

                  /*返回默认数据*/
                  this.formdata.allmoneymolis=0
                  this.formdata.money=this.formdata.shopmoneys
                  this.formdata.allmoney=this.formdata.shopmoneys
                  this.jfdkmoney=0 //共抵扣
                  this.zhekoulv=100 //积分折扣率
                  if(newVal==1){
                      //无优惠

                  }else if(newVal==2){
                        //积分抵现 共抵扣
                       if(this.jfData.deposit>=this.jfData.employ){
                           var changeJf=this.formdata.integral*this.jfData.deposit

                       }else {
                           var changeJf=this.formdata.integral/this.jfData.employ
                       }
                        if(changeJf>this.formdata.shopmoneys){

                            this.jfdkmoney = this.formdata.shopmoneys
                        }else {
                            this.jfdkmoney = changeJf
                        }
                        this.formdata.money = this.formdata.shopmoneys - this.jfdkmoney


                        if(this.jfData.employ<this.jfData.deposit){
                            this.Usejf =this.formdata.shopmoneys/this.jfData.deposit

                        } else {
                            this.Usejf=this.formdata.integral*this.jfData.deposit-this.formdata.shopmoneys/this.jfData.deposit
                        }


                    }else if(newVal==3){
                      //积分折扣率
                      var seeBigNum=[]
                      this.constmerArr.forEach((item,index)=>{
                          seeBigNum.push(item.jf)
                      })
                      seeBigNum=seeBigNum.sort(function(a,b){
                          if(a<b){
                              return -1;
                          }else if(a>b){
                              return 1;
                          }
                          return 0;
                      });
                      var slt
                      for(var i=1;i<seeBigNum.length;i++) {
                          if( this.formdata.integral<=seeBigNum[i]  ){
                              slt=seeBigNum[i-1]
                              break;
                          }else {
                              slt=seeBigNum[i]
                          }

                      }
                      this.constmerArr.forEach((m,n)=>{
                          if(m.jf==slt){
                              this.zhekoulv=m.dz
                          }
                      })
                      if( this.formdata.integral<=seeBigNum[0]){
                          this.zhekoulv=100
                      }
                      this.formdata.money = this.formdata.shopmoneys*this.zhekoulv/100

                    }else if(newVal==4){
                      //会员卡
                    }


                }
            },
            'formdata.money': {
                deep: true,
                handler: function (newVal, oldVal) {

                    if(this.isShowflagadmin){
                        if(this.chooseType==1){
                            this.formdata.shopqiankuan = this.formdata.shopmoneys-newVal-this.formdata.moling
                            this.formdata.shopqiankuan = this.formdata.shopqiankuan-this.formdata.allmoneymolis-this.jfdkmoney
                        }else if(this.chooseType==2){
                            this.formdata.shopqiankuan = this.formdata.shopmoneys-newVal-this.formdata.moling
                            this.formdata.shopqiankuan = this.formdata.shopqiankuan-this.formdata.allmoneymolis-this.jfdkmoney
                        }else if(this.chooseType==3){
                            this.formdata.shopqiankuan = this.formdata.shopmoneys-newVal-this.formdata.moling
                            this.formdata.shopqiankuan = this.formdata.shopqiankuan-this.formdata.allmoneymolis-(this.formdata.shopmoneys - this.formdata.shopmoneys*this.zhekoulv/100)
                        }else if(this.chooseType==4){
                            this.formdata.shopqiankuan=this.formdata.shopmoneys-this.formdata.allmoney-this.formdata.allmoneymolis
                        }
                    }else {
                        this.formdata.shopqiankuan = this.formdata.shopmoneys-newVal-this.formdata.allmoneymolis
                    }
                    this.formdata.allmoney = this.formdata.money

                }
            },
            'searchshopName': {
                deep: true,
                handler: function (newVal, oldVal) {
                    if(this.select=='name3'){
                        this.sid = newVal
                        this.getOrderList(this.page.page, this.page.rows, 2, this.valuedate[0],this.valuedate[1])
                    }else {
                        this.sid = JSON.parse(localStorage.getItem('shop')).id
                    }
                }
            }
        },
        methods: {
            //店铺列表
            getShopList() {
                var data = {
                    cid: this.cid,
                    page: 1,
                    rows: 1000,

                };
                this.$Api.getShopList(data).then(res => {
                    this.shopList = res.data;
                    this.searchshopName = JSON.parse(localStorage.getItem('shop')).id
                });
            },
            //获取所有商品列表
            getOrderList(page,rows,ispay,beantime,endtime){
                this.$Api.getOrderList({
                    page: page,
                    rows: rows,
                    ispay: ispay,
                    cid: this.cid,
                    sid: this.sid,
                    beantime: beantime,
                    endtime:endtime,

                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.goodsListL = res.data
                      this.goodsListL.forEach((m,n)=>{
                          var nums = 0
                          var qery = 0
                          m.goods.forEach((item,index)=>{
                              item.items.forEach((k,v)=>{
                                  nums=nums+k.num
                                  qery++
                              })
                          })
                          m.nums=nums
                          m.qery=qery
                      })
                        this.statisticsSumPaymoney(page,rows,ispay,beantime,endtime)
                        this.statisticsOrderNum(page,rows,ispay,beantime,endtime)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //总数量
            statisticsSumPaymoney(page,rows,ispay,beantime,endtime){
                this.$Api.statisticsSumPaymoney({
                    page: page,
                    rows: rows,
                    ispay: ispay,
                    cid: this.cid,
                    sid: this.sid,
                    beantime: beantime,
                    endtime:endtime,
                }).then(res => {
                    if(res.code==200){
                        this.headerdata.allmoney=res.data.sumPaymoney
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //总数量
            statisticsOrderNum(page,rows,ispay,beantime,endtime){
                this.$Api.statisticsOrderNum({
                    page: page,
                    rows: rows,
                    ispay: ispay,
                    cid: this.cid,
                    sid: this.sid,
                    beantime: beantime,
                    endtime:endtime,
                }).then(res => {
                    if(res.code==200){
                        this.headerdata.numbers=res.data.num
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //修改分页
            onChange(e){
                this.page.page=e
                this.getOrderList(this.page.page,this.page.rows,0,this.valuedate[0],this.valuedate[1])
            },
            handleOk(data){
                if(this.select=='name1'){
                    this.getOrderList(this.page.page,this.page.rows,0,data[0],data[1])
                }else if(this.select=='name2'){
                    this.getOrderList(this.page.page,this.page.rows,1,data[0],data[1])
                }else if(this.select=='name3'){
                    this.getOrderList(this.page.page,this.page.rows,2,data[0],data[1])
                }
                
            },
            slitTag(num){
                this.select=num
                this.sid = JSON.parse(localStorage.getItem('shop')).id
                console.log(this.sid)
                if(num=='name1'){
                    this.getOrderList(1,8,0,this.valuedate[0],this.valuedate[1])
                }else if(num=='name2'){
                    this.getOrderList(1,8,1,this.valuedate[0],this.valuedate[1])
                }else if(num=='name3'){
                    this.getOrderList(1,8,2,this.valuedate[0],this.valuedate[1])
                }


            },
            //积分规则
            getIntegralList(){
                this.$Api.getIntegralList({
                    cid: this.cid
                }).then(res => {
                    if(res.code==200){
                        this.discountListStatus = res.data[0].status
                        this.jfData =  res.data[0]
                        this.constmerArr = JSON.parse(res.data[0].constmer)
                        this.bendanIntegral = Math.floor(this.formdata.allmoney/this.jfData.consume*this.jfData.integral)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            getCustomerByWxuserId(id){
                this.$Api.getCustomerByWxuserId({
                    cid: this.cid,
                    sid: this.sid,
                    userId:id
                }).then(res => {
                    if(res.code==200){
                        this.kehudata = res.data
                        this.formdata.shoptype=res.data.name
                        this.formdata.customerid=res.data.id
                        this.formdata.shopkehu = res.data.money
                        this.formdata.integral = res.data.integral

                        if(res.data.username==null){
                            this.isShowflagadmin=true
                        }else {
                            this.isShowflagadmin=false
                        }

                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            getOrderByOrderId(id){
                this.$Api.getOrderByOrderId({
                    orderId: id
                }).then(res => {
                    if(res.code==200){
                        this.resData=res.data
                        this.colorarray = res.data.goods[0].items
                        this.formdata.goodscode = res.data.goods[0].goodscode
                        this.formdata.shopnames = res.data.goods[0].goodsname
                        this.formdata.ordernumber = res.data.ordercode
                        this.formdata.Img =  res.data.goods[0].goodsimg
                        this.formdata.shopmoney = res.data.money
                        this.formdata.shopmoneys = res.data.totalMoney
                        this.formdata.shopqiankuan = res.data.nomoney
                        this.formdata.type = res.data.deliverymethod
                        this.formdata.remark = res.data.remark
                        this.formdata.count = res.data.goods[0].num
                        this.formdata.allmoney = res.data.money
                        this.formdata.money = res.data.totalMoney
                        this.formdata.name = res.data.username
                        this.formdata.phone = res.data.phone
                        this.formdata.address = res.data.shoppingaddress
                        this.getIntegralList()
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            /*打开弹框待支付*/
            opencommodityModal(data){

                var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                if(!PermisCode.includes('106')){
                    this.$Message.warning('暂无权限');
                     return
                }

                this.formdata.shopqiankuan=0
                this.formdata.allmoneymolis=0
                this.choose.res=1
                this.orderId = data.id
                this.commodityModal=true
                this.formdata.shopname=JSON.parse(localStorage.getItem('shop')).name
                this.getCustomerByWxuserId(data.userid)
                this.getOrderByOrderId(data.id)
            },
            /*打开弹框已支付*/
            openonlinePayModal(data){

                var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
                if(!PermisCode.includes('106')){
                    this.$Message.warning('暂无权限');
                     return
                }

                this.formdata.shopqiankuan=0
                this.formdata.allmoneymolis=0
                this.choose.res=1
                this.orderId = data.id
                this.onlinePayModal=true
                this.formdata.shopname=JSON.parse(localStorage.getItem('shop')).name
                this.getCustomerByWxuserId(data.userid)
                this.getOrderByOrderId(data.id)
            },
            //获取业务员列表
            getAdminList(){
                this.$Api.getAdminList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                    isdel:0
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                            this.formdata.salesman=[]
                            res.data.forEach((item)=>{
                                var rule=item.role.code.split(',')
                                if(rule.indexOf('84')>-1){
                                    this.formdata.salesman.push(item)
                                }
                            })
                        }
                        this.formdata.salesperson = JSON.parse(localStorage.getItem('adminUser')).id
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            //获取银行卡
            getBankList(){
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.formdata.bankList =  res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            moling(){
                //本单欠款

                if(this.formdata.moling>=this.formdata.money){
                    this.$Message.warning('抹零金额不能大于实付金额');
                    return;
                }
                this.formdata.allmoneymolis=this.formdata.allmoneymolis+this.formdata.moling

                //实付金额
                this.formdata.money = (this.formdata.money-this.formdata.moling)
                //合计金额
                this.formdata.allmoney = this.formdata.allmoney-this.formdata.moling
                this.formdata.moling=0

            },
            /**
             * 出售
             * **/
            addsSelectItem(){

                if( this.choose.res!=4 && this.formdata.bank==''){
                    this.$Message.warning("请选择支付方式");
                    return
                }
                /** 支付方式 **/
                var bankmarket=[{
                    bankid:  this.formdata.bank,
                    money: this.formdata.money,
                    yifu: true,
                    quankuan: false
                }]

                /** 发送的表数据 **/
                var goodslist=[]
                this.resData.goods.forEach((item,index)=>{
                    var arr=[]
                    item.items.forEach((m,n)=>{
                        m.nums = m.num
                        m.nums = m.num
                        arr.push(m)
                    })
                    goodslist.push({
                        cid: item.cid,
                        cprice: item.cprice,
                        goodscode: item.goodscode,
                        goodsid: item.goodsid,
                        goodsimg: item.goodsimg,
                        goodsname:item.goodsname,
                        id: item.id,
                        goodsItem:arr,
                        lprice: item.lprice,
                        num: item.num,
                        orderid:item.orderid,
                        sid: item.sid,
                    })
                })
                //如果打折和积分抵现都关了
                if( this.jfData.status=='3'||this.bendanIntegral==null){
                    this.bendanIntegral=0
                }

                if(this.isShowflagadmin){
                    /** 非系统默认客户 **/

                    if( this.choose.res==4 && this.kehudata.balance<this.formdata.allmoney){
                        this.$Message.warning('会员卡余额不足，无法出售');
                        return
                    }
                    /** 判断本单积分是否为null**/
                    if( !this.formSelect.thisBillIntegral){
                        this.formSelect.thisBillIntegral=0
                    }


                    var data={
                        adminid: this.formdata.salesperson, //业务员id
                        appletcode: this.formdata.ordernumber,//商品编号
                        bankmarket: bankmarket, //支付方式
                        banktype: "",
                        cid: this.cid,
                        customerid:this.formdata.customerid,//客户id
                        didscount:this.zhekoulv, //积分折扣
                        discountsmoney: this.jfdkmoney,//优惠金额 积分共抵扣多少 默认抵扣0
                        dixianshengyu: this.formdata.shopmoneys-this.jfdkmoney, //抵现之后剩余多少 默认客户应为 总金额-0
                        money: this.formdata.shopmoneys*this.zhekoulv/100,// 积分打折 后金额（应付）总金额-0
                        goodslist: goodslist,
                        integral: this.formdata.integral, //客户积分 默认客户为 null
                        nomoney: this.formdata.shopqiankuan, //本单欠款
                        orderId: this.orderId, //单据编号
                        paymoney: this.formdata.allmoney,// （实际支付的金额）
                        removemoney: this.formdata.allmoneymolis,//抹零金额总和
                        sid: this.sid,
                        state: 2, //1销售单，2网店订单
                        status: 0,
                        thistotal: this.bendanIntegral,  //本单积分 默认客户为 null
                        total: this.formdata.count, //合计多少件
                        totalmoney: this.formdata.shopmoneys,
                        useintegral:this.Usejf, //使用的积分 默认客户不能使用积分 默认为空
                        zkstate: 4,  //选择优惠方式的状态 1积分抵现 2积分折扣 3会员卡， 4无优惠*/ 默认为无优惠
                        username:this.formdata.name,
                        phone:this.formdata.phone,
                        shoppingaddress:this.formdata.address,
                        remark: this.formdata.remark, //客户留言
                    }


                    this.addsSelectItemloading=true
                    this.$Api.addMarket(data).then(res => {
                        if(res.code==200){
                            this.$Message.success('出售成功');
                            this.$router.push({
                                path:'/openorderDertail',
                                query:{
                                    appletCode:this.formdata.ordernumber
                                }
                            })
                        }else {
                            this.$Message.warning(res.msg);
                        }
                        this.addsSelectItemloading=false
                    }).catch( (err)=> {
                        this.addsSelectItemloading=false
                    });
                }else {

                    /** 系统默认客户 **/
                    var data={
                        adminid: this.formdata.salesperson, //业务员id
                        appletcode: this.formdata.ordernumber,//商品编号
                        bankmarket: bankmarket, //支付方式
                        banktype: "",
                        cid: this.cid,
                        customerid:this.formdata.customerid,//客户id
                        didscount:100, //折扣多少 系统默认100%
                        discountsmoney: 0,//优惠金额 积分共抵扣多少 默认抵扣0
                        dixianshengyu: this.formdata.shopmoneys, //抵现之后剩余多少 默认客户应为 总金额-0
                        money: this.formdata.shopmoneys,//折扣后金额（应付）总金额-0
                        goodslist: goodslist,
                        integral: '', //客户积分 默认客户为 null
                        nomoney: this.formdata.shopqiankuan, //本单欠款
                        orderId: this.orderId, //单据编号
                        paymoney: this.formdata.allmoney,// （实际支付的金额）
                        removemoney: this.formdata.allmoneymolis,//抹零金额总和
                        sid: this.sid,
                        state: 2, //1销售单，2网店订单
                        status: 0,
                        thistotal: this.bendanIntegral,  //本单积分 默认客户为 null
                        total: this.formdata.count, //合计多少件
                        totalmoney: this.formdata.shopmoneys,
                        useintegral: '', //使用的积分 默认客户不能使用积分 默认为空
                        zkstate: 4,  //选择优惠方式的状态 1积分抵现 2积分折扣 3会员卡， 4无优惠*/ 默认为无优惠
                        username:this.formdata.name,
                        phone:this.formdata.phone,
                        shoppingaddress:this.formdata.address,
                        remark: this.formdata.remark, //客户留言
                    }
                    this.$Api.addMarket(data).then(res => {
                        if(res.code==200){
                            this.$Message.success('出售成功');
                            this.$router.push({
                                path:'/openorderDertail',
                                query:{
                                    appletCode:this.formdata.ordernumber
                                }
                            })
                        }else {
                            this.$Message.warning(res.msg);
                        }
                        this.addsSelectItemloading=false
                    }).catch( (err)=> {
                        this.addsSelectItemloading=false
                    });
                }










            },

        }
    };
</script>

<style lang="scss" scoped>
    .historyItem{
        width: 450px;
        height: 240px;
        background-color: #ffffff;
        box-shadow: 0px 3px 10px 0px
        rgba(24, 54, 129, 0.14);
        border-radius: 10px;
        display: inline-block;
        margin: 18px;
        cursor: pointer;
        .typeitem{
            display: block;
            width: 60px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background-color: #e5fff7;
            border-radius: 4px;
            border: solid 1px #46bab2;
            position: relative;
            top: -3px;
            right: -3px;
            color: #46bab2;
        }
        .type-content{
            li{
                height: 30px;
            }
        }
        .ywy{
            text-align: right;
            padding-top: 10px;
        }
    }
    .boximg{
        min-height: 110px;
        position: relative;
        padding-left: 120px;
        .img{
            position: absolute;
            left: 0;
        }
    }

</style>